module.exports = __webpack_public_path__ + "assets/fbb2c01617481922ef96c8a7265604b7.png";